import React from "react";
import "./CascadeBanner.css";

interface Props {
  sourceWorkCode: string;
  sourceLabel: string;
  finishDelta: number;
  totalCascaded: number;
  criticalPathImpact?: boolean;
  onShowList: () => void;
  onClear: () => void;
}

const CascadeBanner: React.FC<Props> = ({
  sourceWorkCode,
  sourceLabel,
  finishDelta,
  totalCascaded,
  criticalPathImpact,
  onShowList,
  onClear,
}) => (
  <div className={`cascade-banner${criticalPathImpact ? " cascade-banner-critical" : ""}`}>
    <span className="cascade-banner-icon">&#x1F517;</span>
    <span className="cascade-banner-msg">
      <strong>{sourceWorkCode}</strong> {sourceLabel} pushed +{finishDelta}d
      &rarr; {totalCascaded} cascaded
      {criticalPathImpact && (
        <span className="cascade-banner-cp"> — Critical Path impacted</span>
      )}
    </span>
    <button className="cascade-banner-btn" onClick={onShowList}>
      Show List
    </button>
    <button className="cascade-banner-btn" onClick={onClear}>
      Clear
    </button>
  </div>
);

export default CascadeBanner;
